import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { saveNavigationRoute } from '../../../actions/actions';
import { IUserData } from '../../../infrastructure/interfaces';
import UsersGroups from '../../../infrastructure/UsersRoles';

export interface IAdminRouteProps extends RouteProps {
  user?: IUserData;
  component: any;
  path: string;
  saveNavigationRoute(navigationRoute: string): void;
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    saveNavigationRoute: (navigationRoute: string) => {
      dispatch(saveNavigationRoute(navigationRoute));
    }
  };
};

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    user: state.user.data
  };
};

//TODO: Need to add to user the UserGroups.superUser here when service completes
@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class AdminRoute extends React.Component<IAdminRouteProps>{

  render() {
    const {
      user,
      component: Component,
      ...rest
    } = this.props;

    this.props.saveNavigationRoute(this.props.path);
    
    return (
      <Route {...rest} render={(props) => {
        return user
          ? user.role === UsersGroups.superUser
            ? <Component />
            : <Redirect to="/SuperUser" />
          : <Redirect to="/Login" />;
      }} />);
  }
}



// WEBPACK FOOTER //
// ./src/components/App/components/SuperUserRouter.tsx